










































































import Vue from 'vue';
import Component from 'vue-class-component';
import { fromEvent } from 'rxjs';
import { Prop } from 'vue-property-decorator';
import Voice from '@/components/template/voice.vue';

@Component({
  components: {
    Voice,
  },
})
export default class Voice05 extends Vue {

  /**
   * ページタイトル
   */
  @Prop()
  public title!: string;

  /**
   * createdフック
   */
  public created(): void {
    document.title = this.title;
  }

}
